import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateNewAttributes } from "../../../../../actions/product";

const UpdateAttributes = ({ groupAttributes, SelectItem, setEdit }) => {
  const dispatch = useDispatch();
  const [loading, setloading] = useState(false);
  const [formData, setformData] = useState({
    name: SelectItem?.name ?? "",
    attributeGroupId: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // VALIDATION CHECK: Stop if fields are empty
    if (!formData.name || !formData.attributeGroupId) {
        return;
    }

    try {
      setloading(true);
      const res = await dispatch(
        updateNewAttributes({ ...formData, sortOrder: 1 }, SelectItem?._id)
      );
      if (res) {
        setloading(false);
        setEdit({
          open: false,
          edit: "",
          title: "",
        });
      }
    } catch (error) {
      setloading(false);
    }
  };

  return (
    <div>
      <div className="px-4 ">
        <form onSubmit={handleSubmit}>
          <div className=" mt-3">
            <input
              type="text"
              className="add-button mt-3"
              required
              placeholder="Name"
              name="name"
              autoComplete="off"
              value={formData.name}
              onChange={(e) =>
                setformData({ ...formData, [e.target.name]: e.target.value })
              }
            />
            <select
              className="add-button mt-2"
              name="attributeGroupId"
              required  // <--- Added required here to enforce selection
              value={formData.attributeGroupId}
              onChange={(e) =>
                setformData({ ...formData, [e.target.name]: e.target.value })
              }
            >
              <option value={""} disabled>
                Select
              </option>
              {groupAttributes?.map((opt) => (
                <option key={opt?._id} value={opt?._id}>
                  {opt?.name}
                </option>
              ))}
            </select>

            <div className=" mt-3 ">
              <button type="submit" className="update-Order-button">
                {loading ? "Loading..." : "Update"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateAttributes;